<template>
  <v-layout column>
    <DiffTable
      :title="tableTitle"
      :unit="unit"
      :calculated="calculated"
      :loading="loading"
      :dictionary-weight="dictionaryWeight"
    />
    <v-btn
      small
      :disabled="isDisabled || disabled"
      :loading="loading"
      block
      @click="updateWeight"
    >
      Изменить
    </v-btn>
  </v-layout>
</template>
<script>
import DiffTable from "./DiffTable.vue";
import * as goodsDetailsApi from "../../../backend/goodsDetailsApi.js";

export default {
  components: { DiffTable },
  props: {
    resource: {
      type: String,
      defaul: "",
    },
    unit: {
      type: String,
      defaul: "",
    },
    quantity: {
      type: Number,
      defaul: 0,
    },
    weight: {
      type: Number,
      defaul: 0,
    },
    dictionaryWeight: {
      type: Number,
      defaul: 0,
    },
    disabled: Boolean,
    isChangedWeight: Boolean,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    calculated() {
      if (!this.dictionaryWeight || this.isChangedWeight) {
        if (this.quantity > 0) {
          return +(this.weight / this.quantity).toFixed(3);
        } else {
          return 0;
        }
      }
      return this.dictionaryWeight;
    },
    tableTitle() {
      return `Вес нетто на ${this.unit ? this.unit : "ед.измерения"}`;
    },
    isDisabled() {
      return this.dictionaryWeight === this.calculated;
    },
  },
  methods: {
    async updateWeight() {
      this.loading = true;
      await goodsDetailsApi.updateWeightNetto(this.resource, this.calculated);
      const message = "Объект изменен";
      this.showInfo(message);
      this.$emit("update", this.calculated);
      this.loading = false;
    },
  },
};
</script>
